import { createSlice } from "@reduxjs/toolkit";
import { InitialFactoryFormData } from "../../ConstantData/InitialData";

const factorySlice = createSlice({
  name: "factory",
  initialState: {
    factoryList: [],
    isError: false,
    errorData: {},
    dataEdit: [],
    initialData: InitialFactoryFormData,
  },
  reducers: {
    getAllFactory: (state, action) => {
      state.factoryList = action.payload;
    },
    getFactory: () => {},
    createFactory: (state, action) => {
      state.factoryList.push({ ...action.payload });
    },
    getFactoryDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state, action) => {
      state.initialData = { ...InitialFactoryFormData };
    },
    updateFactory: (state, action) => {},
    deleteFactory: () => {},
  },
});

export const factorySliceAction = factorySlice.actions;
export default factorySlice.reducer;
